import * as __SNOWPACK_ENV__ from '../../../../env.js';

export default {
  NODE_ENV: __SNOWPACK_ENV__.NODE_ENV,
  COMMIT_HASH: __SNOWPACK_ENV__.SNOWPACK_PUBLIC_COMMIT_HASH,
  APP_VERSION: parseInt(__SNOWPACK_ENV__.SNOWPACK_PUBLIC_APP_VERSION || "999")
};
